module.exports = __webpack_public_path__ + "img/1-17.500d1d34.jpg";